import * as React from 'react';
import * as cn from 'classnames';

import './icon.scss';

interface Props {
    glyph: {
        id: string;
        content: string;
        viewBox: string;
    };
    width?: number | string;
    height?: number | string;
    className?: string;
    styleName?: string;
    onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
    title?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    analyticsInfo?: object;
}

export default class Icon extends React.Component<Props> {
    renderSvg = () => {
        const {
            glyph,
            width = 16,
            height = 16,
            className,
            onClick,
            onMouseEnter,
            onMouseLeave,
            analyticsInfo,
        } = this.props;

        if (!glyph) return null;

        return (
            <svg
                width={width}
                height={height}
                viewBox={glyph.viewBox}
                className={cn(className, '__app-Icon')}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                {...{ ...analyticsInfo }}
            >
                <use xlinkHref={`#${glyph.id}`} />
            </svg>
        );
    };

    render() {
        const { title } = this.props;

        if (title) {
            return (
                <div {...{ title }} styleName="title-wr">
                    {this.renderSvg()}
                </div>
            );
        } else {
            return this.renderSvg();
        }
    }
}
